import { AppBar as MUIAppBar, styled, Theme } from '@nexelem/deprecated-theme';

export const StyledMuiAppBar = styled(MUIAppBar)<{ isJumbo?: boolean }>(({ theme, isJumbo }) => {
  const typedTheme = theme as Theme;
  const { getColor } = typedTheme.palette;
  const { brandColors } = typedTheme.client;
  return {
    zIndex: typedTheme.zIndex.drawer + 1,
    padding: isJumbo ? typedTheme.spacing(2, 8) : typedTheme.spacing(0, 6),
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: getColor(brandColors.background.bars),
    color: getColor(brandColors.text.navigation),
    boxShadow: 'none',
    borderBottom: `${typedTheme.spacing(0.25)} solid ${getColor(brandColors.border.default)}`,
    '& .notification-icon': {
      paddingRight: typedTheme.spacing(7),
    },
    '& .menu-icon': {
      paddingRight: typedTheme.spacing(8),
      '& svg': {
        height: isJumbo ? typedTheme.spacing(10) : 'default',
        width: isJumbo ? typedTheme.spacing(10) : 'default',
      },
    },
    '& .logo-icon': {
      height: isJumbo ? typedTheme.spacing(10) : 'unset',
      width: isJumbo ? typedTheme.spacing(10) : 'unset',
    },
  };
});
